// extracted by mini-css-extract-plugin
export default {"tooltip":"YE-z","arrow":"ZE-z"};